import { FormControl, FormGroup } from '@angular/forms';
import { Breakpoint, CONFIG_FONT_TAGS, ConfigStyleTag } from 'libs/shared/src/models';
import { DEFAULT_CONFIG } from '../default.config';

/**
 * Builds the formgroup for the fonts
 * @returns FormGroup
 */
export function generateTagStylesFormGroup(): FormGroup {
  const group = new FormGroup({});
  CONFIG_FONT_TAGS.forEach((tag) => {
    group.addControl(tag, buildDeviceSizeForm(tag));
  });
  return group;
}

/**
 * Builds the form for a single font
 * @param font to build the form for
 * @returns FormGroup
 */
function buildDeviceSizeForm(tag: ConfigStyleTag): FormGroup {
  return new FormGroup({
    default: buildTagStyleForm(tag, 'default'),
    sm: new FormControl(null),
    lg: new FormControl(null),
    xxl: new FormControl(null)
  });
}

/**
 * Builds the form for a single font
 * @param font to build the form for
 * @returns FormGroup
 */
function buildTagStyleForm(tag: ConfigStyleTag, size: Breakpoint): FormControl {
  const tagConfig = DEFAULT_CONFIG.tagStyles[tag];
  return new FormControl({
    size: tagConfig[size]?.size ?? null,
    lineHeight: tagConfig[size]?.lineHeight ?? null,
    weight: tagConfig[size]?.weight ?? null,
    style: tagConfig[size]?.style ?? null,
    family: tagConfig[size]?.family ?? null,
    textTransform: tagConfig[size]?.textTransform ?? null,
    spacingTop: tagConfig[size]?.spacingTop ?? null,
    spacingBottom: tagConfig[size]?.spacingBottom ?? null
  });
}
